/**
 * @generated SignedSource<<32d6cde2caa4a739aa87f52679c42bce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarSource = "google" | "internal" | "office365";
export type ConferenceProviderOptions = "GOOGLE" | "NONE" | "TEAMS" | "ZOOM";
export type UserPreferencesQuery$variables = {};
export type UserPreferencesQuery$data = {
  readonly viewer: {
    readonly calendars: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: string | null;
          readonly hadErrorOnSync: boolean | null;
          readonly id: string;
          readonly lastSyncDatetime: string | null;
          readonly name: string | null;
          readonly removedFromApi: boolean | null;
          readonly source: CalendarSource;
          readonly sourcePrimary: boolean;
          readonly syncEnabled: boolean;
        };
      }>;
    };
    readonly integrations: {
      readonly zoom: {
        readonly hasMeetingWriteScope: boolean;
      } | null;
    };
    readonly settings: {
      readonly disableExternalUserCalendarLinks: boolean | null;
      readonly enableBrowserExtensionDots: boolean | null;
      readonly enableCalendarDescriptionLinks: boolean | null;
      readonly enableLiveReactions: boolean | null;
      readonly firstWeekDay: string | null;
      readonly preferredConferenceProvider: ConferenceProviderOptions | null;
      readonly theme: string | null;
      readonly timezonePreferences: {
        readonly extraTimezones: ReadonlyArray<{
          readonly timezone: {
            readonly description: string;
            readonly name: string;
            readonly utcOffset: number;
          };
          readonly userLabel: string;
        } | null>;
        readonly preferredTimezone: {
          readonly timezone: {
            readonly description: string;
            readonly name: string;
            readonly utcOffset: number;
          };
          readonly userLabel: string;
        };
      };
    };
    readonly user: {
      readonly email: string;
      readonly id: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"EventFilters_viewer" | "TimezoneSelector_viewer">;
  };
};
export type UserPreferencesQuery = {
  response: UserPreferencesQuery$data;
  variables: UserPreferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TimeZone",
    "kind": "LinkedField",
    "name": "timezone",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "utcOffset",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userLabel",
    "storageKey": null
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "theme",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstWeekDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableBrowserExtensionDots",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableCalendarDescriptionLinks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableLiveReactions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableExternalUserCalendarLinks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredConferenceProvider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimezonePreferences",
      "kind": "LinkedField",
      "name": "timezonePreferences",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserTimezone",
          "kind": "LinkedField",
          "name": "preferredTimezone",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserTimezone",
          "kind": "LinkedField",
          "name": "extraTimezones",
          "plural": true,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMeetingWriteScope",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "CalendarConnection",
  "kind": "LinkedField",
  "name": "calendars",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Calendar",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "source",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sourcePrimary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "removedFromApi",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastSyncDatetime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hadErrorOnSync",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPreferencesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TimezoneSelector_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventFilters_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserPreferencesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserInternalAttributes",
                "kind": "LinkedField",
                "name": "internalAttributes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateConfigured",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserEventFiltersNode",
                "kind": "LinkedField",
                "name": "eventFilters",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeCancelled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeHidden",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeDeclined",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeAllDay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeOutOfOffice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeFocusTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includePersonalMeetings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filterKeywords",
                    "storageKey": null
                  },
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ZoomUserNode",
                "kind": "LinkedField",
                "name": "zoom",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TimeZone",
            "kind": "LinkedField",
            "name": "supportedTimezones",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ec6784cd3097349adae4465ed7a923b",
    "id": null,
    "metadata": {},
    "name": "UserPreferencesQuery",
    "operationKind": "query",
    "text": "query UserPreferencesQuery {\n  viewer {\n    user {\n      id\n      email\n    }\n    settings {\n      theme\n      firstWeekDay\n      enableBrowserExtensionDots\n      enableCalendarDescriptionLinks\n      enableLiveReactions\n      disableExternalUserCalendarLinks\n      preferredConferenceProvider\n      timezonePreferences {\n        preferredTimezone {\n          timezone {\n            name\n            description\n            utcOffset\n          }\n          userLabel\n        }\n        extraTimezones {\n          timezone {\n            name\n            description\n            utcOffset\n          }\n          userLabel\n        }\n      }\n    }\n    integrations {\n      zoom {\n        hasMeetingWriteScope\n        id\n      }\n    }\n    calendars {\n      edges {\n        node {\n          id\n          name\n          source\n          sourcePrimary\n          syncEnabled\n          removedFromApi\n          color\n          lastSyncDatetime\n          hadErrorOnSync\n        }\n      }\n    }\n    ...TimezoneSelector_viewer\n    ...EventFilters_viewer\n    id\n  }\n}\n\nfragment EventFilters_viewer on Viewer {\n  user {\n    internalAttributes {\n      dateConfigured\n      id\n    }\n    eventFilters {\n      includeCancelled\n      includeHidden\n      includeDeclined\n      includeAllDay\n      includeOutOfOffice\n      includeFocusTime\n      includePersonalMeetings\n      filterKeywords\n      id\n    }\n    id\n  }\n  calendars {\n    edges {\n      node {\n        source\n        id\n      }\n    }\n  }\n}\n\nfragment TimezoneSelector_viewer on Viewer {\n  supportedTimezones {\n    description\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "2beda10fcf292b77418583842d775b27";

export default node;
